import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid, LineChart, Line } from 'recharts';
import { PALETTE, eur, libelle, topEtAutres, croise } from './donnees';

const Carte = ({ titre, sous, children, testid }) => (
  <section className="rounded-2xl border border-slate-200 bg-white p-5" data-testid={testid}>
    <h3 className="text-sm font-semibold text-slate-900">{titre}</h3>
    <p className="mb-4 text-xs text-slate-500">{sous}</p>
    {children}
  </section>
);

const fmt = (mesure) => (v) => (mesure === 'ca' ? eur(v) : `${v} contrat${v > 1 ? 's' : ''}`);

export function Camembert({ classement, mesure }) {
  const data = topEtAutres(classement, mesure);
  return (
    <Carte titre="Répartition des activités souscrites" sous="10 premières activités, le reste regroupé" testid="stats-camembert">
      <ResponsiveContainer width="100%" height={340}>
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" innerRadius={70} outerRadius={120} paddingAngle={1} isAnimationActive>
            {data.map((d, i) => <Cell key={d.name} fill={PALETTE[i % PALETTE.length]} />)}
          </Pie>
          <Tooltip formatter={fmt(mesure)} />
          <Legend layout="vertical" align="right" verticalAlign="middle" wrapperStyle={{ fontSize: 11, maxWidth: 260 }} />
        </PieChart>
      </ResponsiveContainer>
    </Carte>
  );
}

const Empile = ({ data, cle, codes, noms, mesure, Graph = BarChart, autres = true }) => (
  <ResponsiveContainer width="100%" height={340}>
    <Graph data={data} margin={{ left: 8, right: 8 }}>
      <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
      <XAxis dataKey={cle} tick={{ fontSize: 11 }} />
      <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => (mesure === 'ca' ? `${Math.round(v / 1000)} k€` : v)} />
      <Tooltip formatter={fmt(mesure)} />
      <Legend wrapperStyle={{ fontSize: 11 }} />
      {[...codes, ...(autres ? ['Autres'] : [])].map((c, i) => (Graph === BarChart
        ? <Bar key={c} dataKey={c} name={noms[c] || 'Autres activités'} stackId="a" fill={PALETTE[c === 'Autres' ? 10 : i]} />
        : <Line key={c} dataKey={c} name={noms[c] || 'Autres activités'} stroke={PALETTE[c === 'Autres' ? 10 : i]} strokeWidth={2} dot={{ r: 3 }} />))}
    </Graph>
  </ResponsiveContainer>
);

export function ParTerritoire({ lignes, classement, mesure }) {
  const top = classement.slice(0, 6);
  const noms = Object.fromEntries(top.map((a) => [a.code, libelle(a)]));
  return (
    <Carte titre="Comparaison par territoire" sous="6 activités principales, empilées par territoire de ventilation du CA" testid="stats-barres-territoire">
      <Empile data={croise(lignes, 'territoire', top.map((a) => a.code), mesure)} cle="territoire" codes={top.map((a) => a.code)} noms={noms} mesure={mesure} />
    </Carte>
  );
}

export function Evolution({ lignes, classement, mesure }) {
  const top = classement.slice(0, 5);
  const noms = Object.fromEntries(top.map((a) => [a.code, libelle(a)]));
  return (
    <Carte titre="Évolution d'une année sur l'autre" sous="5 activités principales par année de couverture" testid="stats-evolution">
      <Empile data={croise(lignes, 'annee', top.map((a) => a.code), mesure, false)} cle="annee" codes={top.map((a) => a.code)} noms={noms} mesure={mesure} Graph={LineChart} autres={false} />
    </Carte>
  );
}
